import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { useEmbedMode } from "./embed-detection";

export function EmbedMeta() {
  const routerLocation = useLocation();
  const embed = useEmbedMode();

  useEffect(() => {
    if (embed) {
      const existingMeta = document.querySelector('meta[name="robots"]');

      if (existingMeta) {
        existingMeta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
      } else {
        const metaTag = document.createElement("meta");
        metaTag.name = "robots";
        metaTag.content = "noindex, nofollow, noarchive, nosnippet";
        document.head.appendChild(metaTag);
      }

      return () => {
        const metaTag = document.querySelector('meta[name="robots"]');
        if (
          metaTag &&
          metaTag.getAttribute("content") === "noindex, nofollow, noarchive, nosnippet"
        ) {
          metaTag.remove();
        }
      };
    }
    return undefined;
  }, [embed, routerLocation.search]);

  return null;
}
